export default "/images/slider-1.png?0b872fd8e5d8c3271e06a218005dc04c";